import { Outlet } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'
import SkipLink from './SkipLink'

export default function Layout() {
  return (
    <div className="flex flex-col min-h-screen">
      <SkipLink />
      <Header />
      <main id="main-content" className="flex-1" tabIndex={-1}>
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}
